export default __webpack_public_path__ + "static/media/kothe-logo-dark.530ab2b6.png";